import ActionTypes from "../ActionTypes/Media";
import { createChannel } from "../../services/channels";
import { createGeneralContent as createGeneralContentRequest } from "../../services/content";
import {
  createPodcast,
  createPodcastEpisode,
  createPodcastSeason,
} from "../../services/podcasts";
import { createEpisode, createSeason, createShow } from "../../services/shows";

/**
 * Thunk running a creation `request`. When the response contains `savedKey`,
 * stores it with `type` (payload: `toPayload(data)`, the whole body by default)
 * and resolves with the body; otherwise, or on error, resolves `false`.
 */
const createAndStore =
  (request, savedKey, type, toPayload = (data) => data) =>
  async (dispatch) => {
    try {
      const data = await request();
      if (!data[savedKey]) {
        return false;
      }
      dispatch({ type, payload: toPayload(data) });
      return data;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

export const createGeneralContent = (generalInfo) =>
  createAndStore(
    () => createGeneralContentRequest(generalInfo),
    "savedMedia",
    ActionTypes.CREATE_GENERAL_CONTENT,
    (data) => ({
      savedMedia: data.savedMedia,
      savedGeneralContent: data.savedGeneralContent,
      generalInfoSubmitted: true,
    })
  );
// second action
export const uploadMedia = (onMediaUpload) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.ON_MEDIA_UPLOAD,
      payload: onMediaUpload.data,
    });
  };
};
//  ADD_AUDIO_TRACKS
export const uploadAudio = (onAudioCreate) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.ADD_AUDIO_TRACKS,
      payload: onAudioCreate.data,
    });
  };
};
//  ADD_SUBTITLES
export const uploadSubtitle = (onAudioCreate) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.ADD_SUBTITLES,
      payload: onAudioCreate.data,
    });
  };
};

export const uploadTrailerMediaId = (onTrailerUpload) => {
  console.log("movie trailer action", onTrailerUpload);
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPLOAD_TRAILER,
      payload: onTrailerUpload,
    });
  };
};
export const getCategories = (categories) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_CATEGORY,
      payload: categories,
    });
  };
};

// EDIT MOVIE GENERAL CONENT
export const getMovieGC = (movieinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_GENERAL_CONTENT_MOVIE,
      payload: movieinfo,
    });
  };
};

// shows
export const createShowGeneralContent = (generalInfo) =>
  createAndStore(
    () => createShow(generalInfo),
    "savedTvShow",
    ActionTypes.CREATE_SHOW_GENERAL_CONTENT
  );

// create season of a tv show
export const createSeasonGeneralContent = (show_id, generalInfo) =>
  createAndStore(
    () => createSeason(show_id, generalInfo),
    "savedSeason",
    ActionTypes.CREATE_SEASON_GENERAL_CONTENT
  );

// create episode
export const createEpisodeGeneralContent = (season_id, generalInfo) =>
  createAndStore(
    () => createEpisode(season_id, generalInfo),
    "savedEpisode",
    ActionTypes.CREATE_EPISODE_GENERAL_CONTENT
  );
export const getTvShowGC = (tvshowinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_GENERAL_CONTENT_SHOW,
      payload: tvshowinfo,
    });
  };
};
export const uploadShowTrailerMediaId = (onTrailerUpload) => {
  console.log("show trailer action", onTrailerUpload);
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPLOAD_TRAILER_SHOW,
      payload: onTrailerUpload,
    });
  };
};
// for episode info page
export const getEpisodeInfo = (episodeinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_GENERAL_CONTENT_EPISODE_INFO,
      payload: episodeinfo,
    });
  };
};

// podcast -------------------------------------------------
export const createPodcastGeneralContent = (generalInfo) =>
  createAndStore(
    () => createPodcast(generalInfo),
    "savedPodcast",
    ActionTypes.CREATE_PODCAST_GENERAL_CONTENT
  );
export const getPodcastGC = (podcastinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_GENERAL_CONTENT_PODCAST,
      payload: podcastinfo,
    });
  };
};
export const uploadPodcastTrailerMediaId = (onTrailerUpload) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPLOAD_TRAILER_PODCAST,
      payload: onTrailerUpload,
    });
  };
};
export const createPodcastEpisodeGeneralContent = (season_id, generalInfo) =>
  createAndStore(
    () => createPodcastEpisode(season_id, generalInfo),
    "savedEpisode",
    ActionTypes.CREATE_PODCAST_EPISODE_GENERAL_CONTENT
  );
export const getPodcastEpisodeInfo = (episodeinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_GENERAL_CONTENT_PODCAST_EPISODE_INFO,
      payload: episodeinfo,
    });
  };
};
export const createPodcastSeasonGeneralContent = (podcast_id, generalInfo) =>
  createAndStore(
    () => createPodcastSeason(podcast_id, generalInfo),
    "savedSeason",
    ActionTypes.CREATE_PODCAST_SEASON_GENERAL_CONTENT
  );
// live channels ================
export const createChannelGeneralContent = (generalInfo) =>
  createAndStore(
    () => createChannel(generalInfo),
    "savedChannel",
    ActionTypes.CREATE_CHANNEL_GENERAL_CONTENT
  );
export const getChannelGC = (channelinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_GENERAL_CONTENT_CHANNEL,
      payload: channelinfo,
    });
  };
};
export const getUserInfo = (userinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.USER_INFO,
      payload: userinfo,
    });
  };
};

export const getAdminGC = (admininfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_ADMIN_INFO,
      payload: admininfo,
    });
  };
};
export const getBroadcastInfo = (broadcstinfo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.BROADCAST_INFO,
      payload: broadcstinfo,
    });
  };
};
